import { Injectable, inject } from '@angular/core';
import { AuthService } from '../auth/services/auth.service';
import {
  FEATURE_LABELS,
  FEATURE_MINIMUM_PLAN,
  FeatureCode,
  PLAN_LABELS,
  PLAN_ORDER,
  PlanCode,
  normalizePlan,
} from './plan-access.model';

@Injectable({ providedIn: 'root' })
export class PlanAccessService {
  private readonly auth = inject(AuthService);

  currentPlan(): PlanCode {
    return normalizePlan(this.auth.currentUser()?.plan);
  }

  currentPlanLabel(): string {
    return PLAN_LABELS[this.currentPlan()];
  }

  hasFeature(feature: FeatureCode): boolean {
    const user = this.auth.currentUser();
    if (!user) return false;

    const explicit = user.features?.[feature];
    if (typeof explicit === 'boolean') return explicit;

    return this.planRank(this.currentPlan()) >= this.planRank(FEATURE_MINIMUM_PLAN[feature]);
  }

  requiredPlan(feature: FeatureCode): PlanCode {
    return FEATURE_MINIMUM_PLAN[feature];
  }

  requiredPlanLabel(feature: FeatureCode): string {
    return PLAN_LABELS[this.requiredPlan(feature)];
  }

  featureLabel(feature: FeatureCode): string {
    return FEATURE_LABELS[feature];
  }

  private planRank(plan: PlanCode): number {
    return PLAN_ORDER.indexOf(plan);
  }
}
